import React, { useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { redirectToExternalUrl } from 'helpers/RouteHelper';
import classNames from 'classnames';
import UpgradeButton from 'components/Buythrough/UpgradeButton';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import { activePlansHasFreeTrial, isStaticRender } from 'helpers/ContentHelper';
import { useSelector } from 'react-redux';
import { useStartFreeTrialMounting } from './FloatingStartFreeTrial.helpers';
import style from './FloatingStartFreeTrial.module.scss';

const { upsellPromoMessage, upsellTrailer_header, upsellPromoDescription } = window.Language;
let title = upsellTrailer_header;
const url = `${_.get(window, 'ExternalConfig.externalSignUpUrl')}/`;
const hideBannerOnPage = window?.ExternalConfig?.signUpBannerHide ?? [];

function getStartFreeTrialVisibility(state) {
  return state?.startFreeTrial?.isVisible;
}

function getStartFreeTrialCompressibility(state) {
  return state?.startFreeTrial?.isCompressed;
}

const FloatingStartFreeTrial = ({ theme }) => {
  const isVisible = useSelector(getStartFreeTrialVisibility);
  const isCompressed = useSelector(getStartFreeTrialCompressibility);
  const { activePlans } = useSelector(state => state.app);
  const path = window.location.pathname;
  const isWatch = path.includes('watch');
  const shouldHide = hideBannerOnPage.filter(page => path.includes(page)).length > 0;
  const onClick = useCallback(({ isJoinNow }) => {
    const { blackFridaySignUpUrl } = window.ExternalConfig;
    handleAnalytics({
      event: Events.UPGRADE_NOW_BUTTON_CLICKED,
      payload: {
        page_item_title: title,
        page_action_location: 'upsell',
      },
    });
    redirectToExternalUrl(isJoinNow ? blackFridaySignUpUrl : url);
  }, []);
  useStartFreeTrialMounting();
  if (isStaticRender() || !activePlans) {
    return null;
  }
  if (!activePlansHasFreeTrial(activePlans)) {
    title = upsellPromoMessage;
  }

  return (
    <div
      className={classNames(
        {
          [style.floatingContainerHidden]: !isVisible || shouldHide,
          [theme['floatingContainer--compressed']]: isCompressed,
        },
        [style.floatingContainer, theme.floatingContainer],
        isWatch && style.floatingContainerWatchPage,
      )}
      aria-hidden={!isVisible}
    >
      <div className={classNames([style.floatingInnerContainer, theme.floatingInnerContainer])}>
        <div className={style.floatingContainerLeft}>
          <div className={classNames([style.floatingContainerTitle, theme.floatingContainerTitle])}>
            {title}
          </div>
          <div
            className={classNames([style.floatingContainerMessage, theme.floatingContainerMessage])}
          >
            {upsellPromoDescription}
          </div>
        </div>
        <UpgradeButton theme={style} onClick={onClick} />
      </div>
    </div>
  );
};

FloatingStartFreeTrial.propTypes = {
  theme: PropTypes.shape({}),
};

FloatingStartFreeTrial.defaultProps = {
  theme: {},
};

export default FloatingStartFreeTrial;
